import { Trans, useTranslation } from 'react-i18next';
import { Typography } from '@ag1/ui';
import styles from './DeliveryFrequencyRibbon.module.scss';

const DeliveryFrequencyRibbon = () => {
  const { t } = useTranslation('modalWindows');

  return (
    <div className={styles.root}>
      <Typography
        variant="body"
        size="2"
        component="p"
        noPadding
        color="black-new"
        className={styles.info}>
        <Trans
          t={t}
          i18nKey="editFrequency.ribbonMessage"
          values={{ followingText: t('editFrequency.followingText') }}
          components={{ bold: <span /> }}
        />
      </Typography>
    </div>
  );
};

export default DeliveryFrequencyRibbon;
